/*
 * @Description: 
 * @Author: zhengfan
 * @Date: 2021-05-19 10:45:00
 * @LastEditTime: 2021-05-24 10:44:26
 * @LastEditors: zhengfan
 */
import React, { createContext, useReducer } from 'react';
import { getToken } from '../common/session'
import moment from 'moment'

export const TrackPropsContext = createContext({});

export const SET_TRACK_PROPS = 'SET_TRACK_PROPS';

const initState = {
    start_time: moment().subtract(6 + moment().day(), 'days').hours(0).startOf('hour'),
    end_time: moment().hours(23).endOf('hour'),
    token:getToken(),
    size: 10,
    page: 1,
    only_filling: false,
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case SET_TRACK_PROPS:
            const newState = { ...action.payload }
            return newState
        default:
            return state
    }
}

export const TrackPropsProvider = props => {
    const propsInfo = props.children.props.location.query?.propsInfo
    const [trackPropsInfo, dispatch] = useReducer(reducer, propsInfo ||initState)
    return (
        <TrackPropsContext.Provider value={{ trackPropsInfo , dispatch}}>
            {props.children}
        </TrackPropsContext.Provider>
    )
}